export const axiosType = {
    ON_CHANGE_LOADING:"ON_CHANGE_LOADING",

    ON_CHANGE_SUCCESS_AXIOS: "ON_CHANGE_SUCCESS_AXIOS",

    ON_CHANGE_VISIBLE_MODAL_AXIOS: "ON_CHANGE_VISIBLE_MODAL_AXIOS",

    ON_CHANGE_VISIBLE_DRAWER_AXIOS: "ON_CHANGE_VISIBLE_DRAWER_AXIOS",
}